<template>
  <div class="detail-box position-header data-home">
    <navHeader :titleList="['信息看板']" />
    <div class="detail-content common-padding">
      <el-row :gutter="20" type="flex">
        <el-col :span="12">
          <el-card>
            <el-row :gutter="20" type="flex">
              <el-col :span="16">
                <div class="company-left">
                  <p class="company-name">{{basicInfo.fullName}}</p>
                  <p class="company-info">{{basicInfo.companyType}}</p>
                  <p class="company-info">{{basicInfo.mobile}}</p>
                  <p class="company-info">{{basicInfo.validity}}</p>
                  <p class="company-info">{{basicInfo.info}}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="company-right">
                  <img src="@/assets/images/download-logo.jpg" alt="" @click="showDownloadLogo" />
<!--                  <p>云快选小程序</p>-->
                  <!--                  <p>{{basicInfo.fullName}}太阳码</p>-->
                  <!--                  <div class="url-box">-->
                  <!--                    <el-image :src="basicInfo.url" :preview-src-list="[basicInfo.url]"></el-image>-->
                  <!--                  </div>-->
                  <!--                  <p class="company-ewm more-text" v-if="basicInfo.url" @click="downloadImage">点击下载小程序码</p>-->
                </div>
              </el-col>
            </el-row>

            <el-dialog
                class="download-dialog"
                title="下载文件"
                :visible.sync="downloadLogoShow"
                width="60%"
                :close-on-click-modal="false">
              <div class="download-logo-btns">
                <el-button type="primary" icon="el-icon-download" @click="downloadImage('cbeSource/downloadSolarCode', '展商太阳码')">下载展商太阳码</el-button>
                <el-button type="primary" icon="el-icon-download"  @click="downloadImage('cbeSource/downloadFissionCode', '展会邀请码')">下载展会邀请码</el-button>
                <el-button type="primary" icon="el-icon-download"  @click="downloadImage('cbeSource/downloadCompanySolarCode', '交换名片太阳码')">下载交换名片太阳码</el-button>
              </div>

              <el-row :gutter="20">
                <el-col :span="5">
                  <el-input clearable v-model.trim="title" placeholder="请输入标题"></el-input>
                </el-col>
                <el-col :span="5">
                  <el-button @click="search" class="btn-search" round icon="el-icon-search">查询
                  </el-button>
                </el-col>
              </el-row>

              <div style="margin-top: 20px">
                <el-table :data="tableData" max-height="300px" style="width: 100%" border>
                  <el-table-column label="序号" type="index" width="60px" fixed align="center"></el-table-column>
                  <el-table-column label="标题" prop="title" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="描述" prop="description" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="资源Url" prop="sourceUrl" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column label="创建时间" prop="createTime" align="center" show-overflow-tooltip sortable="custom"></el-table-column>
                  <el-table-column width="100px" align="center" label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="downloadFile(scope.row.sourceUrl)" icon="el-icon-download">下载
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
                               :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
                               :total="total">
                </el-pagination>
              </div>
            </el-dialog>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <div class="system-info">
              <div class="info-head">
                <p class="system-title">系统通知</p>
                <p class="more-text" @click="noticeMore">更多</p>
              </div>
              <ul class="system-item">
                <li v-for="(item, index) in noticeList" :key="index" @click="noticeItem(item)">{{item.releaseTime}} <span :title="item.title">{{item.title}}</span></li>
              </ul>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" class="common-margin">
        <el-col :span="8">
          <el-card>
            <div class="middle-left">
                <div class="events-title">
                  <p>待办事项</p>
                  <p class="more-text"  @click="toDoMore">更多</p>
                </div>
                <ul class="system-item events-item">
                  <li v-for="(item, index) in toDoList" :key="index" @click="toDoItem(item)">{{item.createTime}}
                    <span :title="item.sourceName">{{item.sourceName}}</span>
                    <span :class="item.isRead === '2' ? 'isRead' : 'unRead'">{{item.isRead === '2' ? '已读' : '未读'}}</span>
                  </li>
                </ul>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card>
            <el-row :gutter="20" type="flex">
              <el-col :span="8">
                <div class="echarts-item">
                  <p>贸易对接</p>
                  <ul class="trade-info">
                    <li>已读：<span>{{isRead}}</span></li>
                    <li @click="onReadClick">未读：<span>{{onRead}}</span></li>
                  </ul>
                  <div class="echarts-pie">
                    <pie :pieData="tradeData" />
                  </div>
                  <div class="echarts-text pie-text">
                    今日： <span>{{today}}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="echarts-item">
                  <p>收藏</p>
                  <div class="echarts-part">
                    <histogram :histogramData="collectionData" />
                  </div>
                  <div class="echarts-text">
                    收藏总数： <span>{{collectionTotal}}</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="echarts-item">
                  <p>分享</p>
                  <div class="echarts-part">
                    <histogram :histogramData="shareData" />
                  </div>
                  <div class="echarts-text">
                    被分享总数： <span>{{shareTotal}}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <p class="data-intro">CBE云快选·需求广场·推荐
        ·您可以登录CBE云快选小程序，浏览首页需求广场中的贸易线索，以获取贸易商机；
        ·同时您可以在需求广场中发布需求，主动寻找合作，增加需求曝光~</p>
      <div class="tab-type">
        <el-radio-group v-model="tabPosition" @change="tabClick">
          <el-radio-button label="6">找货</el-radio-button>
          <el-radio-button label="3">找代理/分销</el-radio-button>
          <el-radio-button label="4">找工厂</el-radio-button>
          <el-radio-button label="5">找合作</el-radio-button>
        </el-radio-group>
      </div>
      <ul class="data-box">
        <li v-for="(item, index) of dataAll" :key="index" v-if="dataAll.length > 0">
          <el-card>
            <p class="item-name">{{item.companyName}}</p>
            <div class="item-text">
              <span v-if="item.one">{{item.one}}</span>
              <span v-if="item.two">{{item.two}}</span>
            </div>
<!--            <p class="item-intro">{{item.supplementtaryIntroduction}}</p>-->
            <div class="item-content item-6" v-if="tabPosition === '6'">
              <p>公司规模：{{item.companySize}}</p>
              <p>需求：{{item.demandEtc}}</p>
              <p>地域要求：{{item.regionalRequirements}}</p>
              <p>需求有效期：{{item.demandDate}}</p>
            </div>
            <div class="item-content item-3" v-if="tabPosition === '3'">
              <p v-if="item.brandCategory">品牌品类：{{item.brandCategory}}</p>
              <p v-if="item.brandSellingPoints">品牌卖点：{{item.brandSellingPoints}}</p>
              <p v-if="item.offlineChannel">需求渠道：{{item.offlineChannel}}</p>
              <p v-if="item.regionalRequirements">地域要求：{{item.regionalRequirements}}</p>
              <p v-if="item.retailPriceRange">价格区间：{{item.retailPriceRange}}</p>
              <p v-if="item.scaleRequirements">规模要求：{{item.scaleRequirements}}</p>
              <p v-if="item.demandDate">需求有效期：{{item.demandDate}}</p>
            </div>
            <div class="item-content item-4" v-if="tabPosition === '4'">
              <p v-if="item.forWhatProducts">需求：{{item.forWhatProducts}}</p>
              <p v-if="item.demandCategory">需求品类：{{item.demandCategory}}</p>
              <p v-if="item.demandMaterial">需求原料/材料：{{item.demandMaterial}}</p>
              <p v-if="item.deliveryRequirements">交期要求：{{item.deliveryRequirements}}</p>
              <p v-if="item.demandMagnitude">需求数量：{{item.demandMagnitude}}</p>
              <p v-if="item.demandSpecification">需求规格：{{item.demandSpecification}}</p>
              <p v-if="item.packagingCategory">需求包装类型：{{item.packagingCategory}}</p>
              <p v-if="item.oemProducts">需求代工产品：{{item.oemProducts}}</p>
              <p v-if="item.oemRequirements">代工要求：{{item.oemRequirements}}</p>
              <p v-if="item.regionalRequirements">地域要求：{{item.regionalRequirements}}</p>
              <p v-if="item.requirement">要求：{{item.requirement}}</p>
              <p v-if="item.demandDate">需求有效期：{{item.demandDate}}</p>
            </div>
            <div class="item-content item-5" v-if="tabPosition === '5'">
              <p>{{item.demandRequirements}}</p>
              <p>需求有效期：{{item.demandDate}}</p>
            </div>
            <p class="item-time">发布于：{{item.createTime}}</p>
            <p class="item-operate">贸易对接</p>
          </el-card>
          <div class="item-mask">
            <div class="mask-content">
<!--              <el-image :src=""></el-image>-->
              <div class="item-image"></div>
              <p>扫描CBE小程序</p>
            </div>
          </div>
        </li>
        <el-empty :image-size="200" v-if="dataAll.length === 0"></el-empty>
      </ul>
    </div>

    <el-dialog title="提醒内容" width="40%" :visible.sync="dialogShow">
      <el-scrollbar>
        <div style="max-height: calc(100vh - 600px)">
          <p style="margin-bottom: 10px; font-weight: 700; text-indent: 2em" v-for="(item, index) of basicInfo.isRemind" :key="index">{{item}}</p>
        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import histogram from '../../components/histogram'
import pie from '../../components/pie'

export default {
  name: 'index',
  data () {
    return {
      dialogShow: false,
      remindContent: '',
      basicInfo: {
        companyType: '',
        fullName: '',
        validity: '',
        url: '',
        info: '',
        isRemind: []
      },
      noticeList: [],
      toDoList: [],
      today: '',
      isRead: '',
      onRead: '',
      tradeData: [],
      collectionData: [],
      collectionTotal: '',
      shareData: [],
      shareTotal: '',
      // tradeData: [],
      // tradeTotal: '',
      // throughData: [],
      tabPosition: '6',
      dataAll: [],
      downloadLogoShow: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      title: ''
    }
  },
  components: {
    navHeader,
    histogram,
    pie
  },
  created () {
    this.getNoticeList()
    this.getToDoList()
    this.getBasicInfo()
    // 1 收藏 2 分享 3 贸易对接 4 浏览次数
    this.getAnalysisData('1')
    this.getAnalysisData('2')
    this.getAnalysisData('3')
    this.getAnalysisData('4')
    this.getTrade()
    // 6找货  3招代理  4找工厂  5找合作
    this.getDatAll('6')
  },
  methods: {
    async getNoticeList () {
      let params = {
        currentPage: 1,
        pageSize: 6
      }
      let {data: res} = await this.$http.post(
        '/notice/getPageList',
        params
      )
      if (res.code === '200') {
        this.noticeList = res.data.records
      }
    },
    async getToDoList () {
      let params = {
        currentPage: 1,
        pageSize: 8
      }
      let {data: res} = await this.$http.post(
        '/pendingMatters/getPageList',
        params
      )
      if (res.code === '200') {
        this.toDoList = res.data.records
        console.log(this.toDoList)
      }
    },
    async getBasicInfo () {
      let {data: res} = await this.$http.get('/homePage/getBaseInfo')
      if (res.code === '200') {
        this.dialogShow = !!res.data.isRemind
        this.basicInfo = res.data
        const isRemind = res.data.isRemind ? res.data.isRemind.split('！') : []
        this.basicInfo.isRemind = isRemind
      }
    },
    async getTrade () {
      let {data: res} = await this.$http.post('/analysisRecord/getTrade')
      if (res.code === '200') {
        this.today = res.data['今日新增']
        this.isRead = res.data['已读']
        this.onRead = res.data['未读']
        this.tradeData.push({
          name: '已读',
          value: res.data['已读']
        }, {
          name: '未读',
          value: res.data['未读']
        })
      }
    },
    async getAnalysisData (type) {
      let {data: res} = await this.$http.post('/analysisRecord/getAnalysisData', { type })
      if (res.code === '200') {
        if (type === '1') {
          this.collectionData = []
          for (let key in res.data.data) {
            this.collectionData.push({
              name: key,
              value: res.data.data[key]
            })
          }
          this.collectionTotal = res.data.total
        } else if (type === '2') {
          this.shareData = []
          for (let key in res.data.data) {
            this.shareData.push({
              name: key,
              value: res.data.data[key]
            })
          }
          this.shareTotal = res.data.total
        } else if (type === '3') {
          this.tradeData = []
          for (let key in res.data.data) {
            this.tradeData.push({
              name: key,
              value: res.data.data[key]
            })
          }
          this.tradeTotal = res.data.total
        }
      }
    },
    async getDatAll (findType) {
      this.dataAll = []
      let params = {
        currentPage: 1,
        pageSize: 6,
        findType
      }
      let {data: res} = await this.$http.post(
        '/info/getSupplyDemandList',
        params
      )
      if (res.code === '200') {
        this.dataAll = res.data.records
      }
    },
    onReadClick () {
      this.$router.push('tradeDocking')
    },
    showDownloadLogo () {
      this.downloadLogoShow = true
      this.getPageList()
    },
    // 下载图片
    downloadImage (url, name) {
      this.$http.get(url, {responseType: 'blob'}).then((res) => {
        console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data])
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = this.basicInfo.fullName + name + '.png'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    noticeMore () {
      this.$router.push({
        name: 'SystemNotice'
      })
    },
    noticeItem (item) {
      this.$router.push({
        name: 'SystemNoticeDetail',
        params: {
          id: item.id
        }
      })
    },
    toDoMore () {
      this.$router.push({
        name: 'ToDo'
      })
    },
    toDoItem (item) {
      let name = ''
      switch (item.sourceType) {
        case '1':
          name = 'RhDetail'
          break
        case '2':
          name = 'AddBrand'
          break
        case '3':
          name = 'MajorDetail'
          break
        case '4':
          name = 'AddMajorProduct'
          break
        case '6':
          name = 'AddFactory'
          break
        case '8':
          name = 'AddService'
          break
        case '9':
          name = 'home'
          break
        default:
          break
      }
      if (!name) return
      // if (item.sourceType === '6') {
      //   name = 'AddFactory'
      // } else if ()
      this.$router.push({
        name: name,
        params: {
          id: item.sourceId,
          type: 'edit'
        }
      })
      this.$http.post('/pendingMatters/update', {id: item.id})
    },
    tabClick (val) {
      this.getDatAll(val)
    },
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        title: this.title
      }
      let {data: res} = await this.$http.post(
        '/cbeSource/getPageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    downloadFile (url) {
      const list = url ? url.split(',') : []
      list.forEach((item) => {
        if (item.includes('.png') || item.includes('.jpg') || item.includes('.webp')) {
          this.$common.downloadImageNew(item, item)
        } else {
          if (item) window.open(item)
        }
      })
    }
  }
}
</script>

<style lang="less">
.download-dialog {
  .el-dialog {
    margin-top: 10vh !important;
  }
}
</style>

<style scoped lang="less">
.data-home .el-card {
  border-radius: 8px;
}
.company-left {
  .company-name {
    margin-bottom: 60px;
    font-size: 22px;
    font-weight: 600;
    color: #6da09c;
  }
  .company-info {
    margin-bottom: 20px;
    font-size: 20px;
  }
}
.company-right img{
  width: 100%;
  cursor: pointer;
  //text-align: center;
  //p {
  //  margin-bottom: 6px;
  //}
  //.url-box{
  //  .el-image {
  //    width: 120px;
  //    height: auto;
  //  }
  //}
  //.company-ewm {
  //  display: inline-block;
  //  margin-top: 6px;
  //}
}
.download-logo-btns {
  margin-bottom: 20px;
}
.system-info {
  .info-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .system-title {
    font-size: 22px;
    font-weight: 600;
    color: #6da09c;
  }
}
.middle-left {
  .events-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }
  .events-item {
    height: 300px;
    span:last-child {
      width: 40px;
      font-weight: 600;
      text-align: right;
    }
    .isRead {
      color: #5ab1ef;
    }
    .unRead {
      color: #ff0000;
    }
  }
}
.echarts-item {
  text-align: center;
  .trade-info {
    margin: 20px auto 0;
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      font-size: 14px;
      span {
        font-size: 20px;
      }
    }
    li:first-child {
      color: #5ab1ef;
    }
    li:last-child {
      color: #24b450;
      cursor: pointer;
    }
  }
  .echarts-pie {
    width: 100%;
    height: 250px;
  }
  .echarts-part {
    width: 100%;
    height: 300px;
  }
  .echarts-text {
    font-size: 14px;
    span {
      font-size: 20px;
      font-weight: 700;
    }
  }
  .pie-text {
    color: #f5e637;
  }
}
.more-text {
  font-size: 14px;
  color: #6da09c;
  border-bottom: 1px solid #6da09c;
  cursor: pointer;
}
.system-item {
  height: 160px;
  overflow: auto;
  font-size: 16px;
  line-height: 20px;
  li {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  span:first-child {
    display: inline-block;
    color: #6da09c;
    width: calc(100% - 220px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.data-intro {
  margin: 30px 0;
  font-size: 24px;
  font-weight: 600;
  text-indent: 2em;
}

.tab-type {
  margin: 30px 0;
}

.data-box {
  display: flex;
  flex-wrap: wrap;
  .el-empty {
    margin: 0 auto;
  }
  li {
    position: relative;
    //width: 11.6%;
    width: 15%;
    //margin-right: 1%;
    margin-right: 2%;
    margin-bottom: 24px;
    &:nth-child(6n) {
      margin-right: 0;
    }
    &:hover .item-mask {
      display: block;
    }
    .item-mask {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background: rgba(0, 0, 0, .6);
      .mask-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .item-image {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          border-radius: 80px;
          background: url("../../assets/images/demo.jpg") no-repeat center center;
          background-size: contain;
        }
        .el-image {
          width: 140px;
          height: 140px;
          border-radius: 50px;
        }
        p {
          width: 120px;
          text-align: center;
          margin-top: 20px;
          color: #fff;
        }
      }
    }
    .item-name {
      height: 42px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 600;
    }
    .item-text {
      height: 50px;
      font-size: 12px;
      span {
        display: inline-block;
        padding: 4px 6px;
        background-color: #eee;
        border-radius: 4px;
        margin-right: 6px;
        margin-bottom: 4px;
      }
    }
    .item-content {
      min-height: 120px;
      margin: 10px 0;
      padding: 10px 6px 6px 6px;
      background-color: #eee;
      border-radius: 4px;
      p {
        font-size: 12px;
        margin-bottom: 4px;
      }
    }
    .item-6 {
      min-height: 110px;
    }
    .item-3 {
      min-height: 180px;
      p:nth-child(2) {
        margin-bottom: 20px;
      }
    }
    .item-4 {
      min-height: 180px;
    }
    .item-5 p:last-child {
      margin-top: 10px;
    }
    .item-intro {
      height: 80px;
      margin: 16px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    .item-time {
      font-size: 12px;
      color: #aaa;
    }
    .item-operate {
      position: relative;
      box-sizing: border-box;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 40px 0 10px 0;
      padding-left: 30px;
      font-size: 13px;
      border-radius: 15px;
      background: linear-gradient(132deg, #22DDB2 0%, #009FF5 100%);
      color: #fff;
      &::before {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        background: url('../../assets/images/icon-wx.png') no-repeat center center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dataHome/index.vue